/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobStatisticsRequest {
    getFixupPrototypeFunction() { return BackgroundJobStatisticsRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobStatisticsRequest>): BackgroundJobStatisticsRequest {
        let obj = Object.assign(new BackgroundJobStatisticsRequest(), model);
        BackgroundJobStatisticsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobStatisticsRequest>): BackgroundJobStatisticsRequest {
        if (!model) return null;
        return BackgroundJobStatisticsRequest.newInstance(<BackgroundJobStatisticsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobStatisticsRequest) {
        if (!obj) return;

        models.BackgroundJobStatisticsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobStatisticsRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobStatisticsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Filter to threads in this executor
     */
    executor: models.BackgroundJobExecutor;

    /**
     * If true, invalidation counters will be returned
     */
    include_invalidations: boolean;

    /**
     * If true, query counters will be returned
     */
    include_query_counters: boolean;

    /**
     * If set, query counters per caller will be returned for the selected context
     */
    include_query_counters_per_caller: string;

    /**
     * If true, a new heap analysis is started
     */
    trigger_heap_analysis: boolean;

    /**
     * If true, the historical heap analysis will be returned
     */
    include_heap_analysis: boolean;

}
